import { combineReducers } from 'redux';
import produce from 'immer';
import { ApiKeyActionType, ApiKeyAction } from '../../actions/apiKeyActions';

type LoadingState = { loading: boolean; loadingError: string };
type DeletingState = { deleting: boolean; deletingError: string };
type EditingStates = { editing: boolean; editingError: string };

export type ApiKeyState = LoadingState & DeletingState & EditingStates;

interface ApiKeyStatesByKey {
  [key: string]: ApiKeyState;
}

const loading = (state = false, action: ApiKeyAction) => {
  switch (action.type) {
    case ApiKeyActionType.LIST_PERSONAL_API_KEYS:
      return true;
    case ApiKeyActionType.LIST_PERSONAL_API_KEYS_OK:
    case ApiKeyActionType.LIST_PERSONAL_API_KEYS_ERROR:
      return false;
    default:
      return state;
  }
};

const loadingError = (state = '', action: ApiKeyAction) => {
  switch (action.type) {
    case ApiKeyActionType.LIST_PERSONAL_API_KEYS:
      return '';
    case ApiKeyActionType.LIST_PERSONAL_API_KEYS_ERROR:
      return action.error;
    default:
      return state;
  }
};

const creating = (state = false, action: ApiKeyAction) => {
  switch (action.type) {
    case ApiKeyActionType.CREATE_PERSONAL_API_KEY:
      return true;
    case ApiKeyActionType.CREATE_PERSONAL_API_KEY_OK:
    case ApiKeyActionType.CREATE_PERSONAL_API_KEY_ERROR:
      return false;
    default:
      return state;
  }
};

const createError = (state = '', action: ApiKeyAction) => {
  switch (action.type) {
    case ApiKeyActionType.CREATE_PERSONAL_API_KEY:
      return '';
    case ApiKeyActionType.CREATE_PERSONAL_API_KEY_ERROR:
      return action.error;
    default:
      return state;
  }
};

const byId = (state: ApiKeyStatesByKey = {}, action: ApiKeyAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ApiKeyActionType.LIST_PERSONAL_API_KEYS_OK: {
        action.data.forEach((apiKey) => {
          draft[apiKey.id] = {} as ApiKeyState;
        });

        break;
      }
      case ApiKeyActionType.CREATE_PERSONAL_API_KEY_OK: {
        draft[action.data.id] = {} as ApiKeyState;
        break;
      }
      case ApiKeyActionType.DELETE_PERSONAL_API_KEY: {
        draft[action.id].deleting = true;
        draft[action.id].deletingError = '';
        break;
      }
      case ApiKeyActionType.DELETE_PERSONAL_API_KEY_OK: {
        delete draft[action.id];
        break;
      }
      case ApiKeyActionType.DELETE_PERSONAL_API_KEY_ERROR: {
        draft[action.id].deleting = false;
        draft[action.id].deletingError = action.error;
        break;
      }
      case ApiKeyActionType.EDIT_PERSONAL_API_KEY: {
        draft[action.id].editing = true;
        draft[action.id].editingError = '';
        break;
      }
      case ApiKeyActionType.EDIT_PERSONAL_API_KEY_OK: {
        draft[action.id].editing = false;
        break;
      }
      case ApiKeyActionType.EDIT_PERSONAL_API_KEY_ERROR: {
        draft[action.id].editing = false;
        draft[action.id].editingError = action.error;
        break;
      }
      case ApiKeyActionType.GET_PERSONAL_API_KEY: {
        draft[action.id].loading = true;
        draft[action.id].loadingError = '';
        break;
      }
      case ApiKeyActionType.GET_PERSONAL_API_KEY_OK: {
        draft[action.id].loading = false;
        draft[action.id].loadingError = '';
        break;
      }
      case ApiKeyActionType.GET_PERSONAL_API_KEY_ERROR: {
        draft[action.id].loading = false;
        draft[action.id].loadingError = action.error;
        break;
      }
      default:
        return state;
    }
  });

export default combineReducers({
  loading,
  creating,
  loadingError,
  createError,
  byId,
});
